import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import NotyfContext from "../../contexts/NotyfContext";
import { getCatalogSimProducts } from "../../redux/slices/sims";
import { useNavigate } from "react-router-dom";
import Loader from "../../components/Loader";
import { Helmet } from "react-helmet-async";
import { Container } from "react-bootstrap";
import PurchaseOrderProduct from "./PurchaseOrderProduct";
import FloatingCart from "./FloatingCart";
import { storePurchaseOrder } from "../../redux/slices/purchaseOrders";
import { getBillingPreferences } from "../../redux/slices/preferences";

const PurchaseOrders = () => {
  const [isLoading, setIsLoading] = useState(true);
  const catalog_sim_products = useSelector(
    (state) => state.sims.catalog_sim_products
  );
  const dispatch = useDispatch();
  const notyf = useContext(NotyfContext);
  const navigate = useNavigate();
  const { user } = useSelector((state) => state.user);
  const { impersonationUser } = useSelector((state) => state.impersonationUser);
  const [activeUser, setActiveUser] = useState({});
  const basket = useSelector((state) => state.purchaseOrders.basket);

  useEffect(() => {
    setActiveUser(impersonationUser.id ? impersonationUser : user);
  }, [user, impersonationUser]);

  useEffect(() => {
    const fetchSimProducts = async () => {
      await Promise.all([
        dispatch(getCatalogSimProducts({ type: "purchase" })),
        dispatch(getBillingPreferences()),
      ])
        .then(() => {
          setIsLoading(false);
        })
        .catch((error) => {
          navigate("/auth/500");
        });
    };

    if (activeUser.id) {
      fetchSimProducts();
    }
  }, [activeUser, dispatch, notyf, navigate]);

  console.log("BASKET:", basket);

  const submitPurchaseOrder = async () => {
    const requestPayload = {
      items: basket.map((item) => ({
        id: item.catalogueSimProductId.simProductId,
        quantity: item.quantity,
        price: item.price,
      })),
    };

    await dispatch(storePurchaseOrder({ data: requestPayload }))
      .then(() => {
        notyf.open({
          type: "success",
          message: "Purchase Order successfully submitted",
          duration: 5000,
          ripple: true,
          dismissible: false,
          position: {
            x: "center",
            y: "top",
          },
        });
      })
      .catch((error) => {
        notyf.open({
          type: "danger",
          message: error,
          duration: 5000,
          ripple: true,
          dismissible: false,
          position: {
            x: "center",
            y: "top",
          },
        });
      });
  };

  if (isLoading) {
    return <Loader />;
  }
  return (
    <React.Fragment>
      <Helmet title="Purchase SIM Cards" />
      <Container fluid className="p-0">
        <div className="products-list">
          {catalog_sim_products.map((product) => {
            return <PurchaseOrderProduct product={product} />;
          })}
        </div>
      </Container>
      <FloatingCart onSubmit={submitPurchaseOrder} />
    </React.Fragment>
  );
};

export default PurchaseOrders;
